import type { NotaryModules } from '@izimi/modules';

import { communicationsModule } from './communications';
import { contactsModule } from './contacts';
import { documentsModule } from './documents';
import { historyLogModule } from './historyLog';
import { notaryModule } from './notary';
import { notificationsModule } from './notifications';
import { postalCodesModule } from './postalCodes';
import { publicModule } from './public';
import { sharedModule } from './shared';
import { studyModule } from './study';
import { userModule } from './user';
import { vaultModule } from './vault';

export const modules: NotaryModules = {
  communications: communicationsModule,
  contacts: contactsModule,
  user: userModule,
  public: publicModule,
  notary: notaryModule,
  documents: documentsModule,
  historyLog: historyLogModule,
  notifications: notificationsModule,
  postalCodes: postalCodesModule,
  vault: vaultModule,
  shared: sharedModule,
  study: studyModule,
};
